import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Quote, Scale, Gavel, Shield, Landmark } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    text: "We are very satisfied with the level and quality of services provided. Very hands-on approach from partners at the firm and easily accessible at all times. Flexible approach to the general business environment when pitching for work.",
    client: "Global Tech Solutions",
    logo: "https://static.wixstatic.com/media/89dc71_4486f4967c8845b5aa56ce87056d3fcb~mv2.png/v1/crop/x_40,y_43,w_324,h_124/fill/w_184,h_76,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202026-02-08%20at%202_00_04%E2%80%AFPM.png"
  },
  {
    id: 2,
    text: "We would highly recommend LCaaS for their seamless service and solid understanding of law. We have been using them for a range of matters and are very pleased by their exceptional service standards.",
    client: "FinServe International",
    logo: "https://static.wixstatic.com/media/89dc71_4a606b574f774fdab8d480129a7349be~mv2.png/v1/crop/x_76,y_33,w_430,h_149/fill/w_191,h_70,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202026-02-08%20at%201_58_03%E2%80%AFPM.png"
  },
  {
    id: 3,
    text: "We have worked with Anshoo for a number of years. We value our relationship with LCaaS. Anshoo provides outstanding legal advice and insights, is highly professional, and prompt in handling our business.",
    client: "Apex Business Group",
    logo: "https://static.wixstatic.com/media/89dc71_1ea4ccb2e0d1460e882317392ed87088~mv2.png/v1/fill/w_196,h_82,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-12-28%20at%2010_12_05%E2%80%AFPM.png"
  },
  {
    id: 4,
    text: "Their expertise in navigating complex regulatory frameworks for MSMEs is unparalleled. The strategic guidance we received ensured our absolute compliance while saving significant time and resources.",
    client: "Horizon E-Commerce",
    logo: "https://static.wixstatic.com/media/89dc71_f3dc5837e6d54a24b81f1a54083e5cd1~mv2.png/v1/fill/w_196,h_89,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-12-27%20at%203_26_52%E2%80%AFPM.png"
  },
  {
    id: 5,
    text: "A truly reliable legal partner. The firm's proactive risk mitigation strategies and attention to cross-border operational details have been a major asset to our international expansion.",
    client: "AKB Revolt Pvt Ltd.",
    logo: "https://static.wixstatic.com/media/89dc71_bd2e08da586e4e47a0ed95700ff8e51d~mv2.jpeg/v1/fill/w_135,h_123,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/hhh.jpeg"
  },
  {
    id: 6,
    text: "The team's attention to detail and professional integrity is unmatched. They have successfully guided us through complex secretarial compliances and secretarial audits with ease.",
    client: "Sterling Enterprises",
    logo: "https://static.wixstatic.com/media/89dc71_d09f4fefa5fa46a5b6551f693caa4661~mv2.png/v1/fill/w_191,h_76,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202026-02-08%20at%201_57_55%E2%80%AFPM.png"
  }
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
    }, 4500);
    return () => clearInterval(timer);
  }, []);

  const handleCardClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <section className="flex flex-col md:flex-row h-[750px] md:h-[700px] bg-slate-50 overflow-hidden relative border-t border-slate-200">
      
      {/* Side Label */}
      <div className="w-full md:w-36 bg-[#eaf2f8] flex items-center justify-center p-6 md:p-0 z-20 border-r border-[#0c3754]/10 relative shadow-[5px_0_15px_rgba(0,0,0,0.03)]">
        <h2 className="md:-rotate-90 tracking-[0.5em] md:tracking-[0.6em] text-[#0c3754] font-serif text-xl md:text-3xl whitespace-nowrap uppercase font-bold">
          Testimonials
        </h2>
      </div>

      <div className="flex-1 relative flex items-center justify-center w-full overflow-hidden px-4 md:px-8">
        
        {/* Animated Background Icons */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden z-0">
          <motion.div animate={{ y: [0, -20, 0], rotate: [0, 5, 0] }} transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }} className="absolute top-[10%] left-[5%] text-[#0c3754] opacity-[0.04]">
            <Scale size={180} strokeWidth={1} />
          </motion.div>
          <motion.div animate={{ y: [0, 20, 0], rotate: [0, -5, 0] }} transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }} className="absolute bottom-[10%] left-[8%] text-[#0c3754] opacity-[0.04]">
            <Shield size={160} strokeWidth={1} />
          </motion.div>
          <motion.div animate={{ y: [0, -25, 0], rotate: [0, -5, 0] }} transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }} className="absolute top-[15%] right-[8%] text-[#0c3754] opacity-[0.04]">
            <Gavel size={170} strokeWidth={1} />
          </motion.div>
          <motion.div animate={{ y: [0, 25, 0], rotate: [0, 5, 0] }} transition={{ duration: 11, repeat: Infinity, ease: "easeInOut" }} className="absolute bottom-[15%] right-[5%] text-[#0c3754] opacity-[0.04]">
            <Landmark size={190} strokeWidth={1} />
          </motion.div>
        </div>

        {/* Cards Container */}
        <div className="relative w-full max-w-6xl h-full flex items-center justify-center perspective-1000 z-10">
          {testimonials.map((testimonial, index) => {
            const diff = index - currentIndex;
            const isClickable = Math.abs(diff) === 1;

            return (
              <motion.div
                key={testimonial.id}
                onClick={() => isClickable && handleCardClick(index)}
                animate={{
                  y: diff === 0 ? 0 : diff * 200,
                  scale: diff === 0 ? 1 : 0.92,
                  opacity: diff === 0 ? 1 : Math.abs(diff) === 1 ? 0.4 : 0,
                  zIndex: 10 - Math.abs(diff),
                }}
                transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                className={`absolute w-full md:w-[90%] bg-[#0c3754] rounded-xl p-8 md:p-12 shadow-2xl border border-white/10 ${
                  isClickable ? 'cursor-pointer hover:border-white/30' : 'pointer-events-none'
                } ${diff === 0 ? 'pointer-events-auto' : ''}`}
              >
                <div className="flex flex-col items-center text-center">
                  <Quote size={32} className="text-[#78BE20] mb-6 opacity-80" />
                  
                  <p className="text-white/90 text-sm md:text-lg font-light leading-relaxed mb-8 md:px-12">
                    "{testimonial.text}"
                  </p>
                  
                  <div className="w-16 h-[1px] bg-white/20 mb-6" />
                  
                  {/* Client Name */}
                  <h4 className="text-[#78BE20] font-semibold tracking-[0.2em] text-[10px] md:text-xs uppercase mb-4">
                    {testimonial.client}
                  </h4>

                  {/* Client Logo - Added here */}
                  <div className="bg-white/95 p-3 rounded-lg shadow-inner">
                    <img 
                      src={testimonial.logo} 
                      alt={`${testimonial.client} logo`}
                      className="h-8 md:h-10 w-auto object-contain"
                    />
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>

        {/* Vertical Pagination */}
        <div className="hidden md:flex absolute right-8 top-1/2 -translate-y-1/2 flex-col gap-3 z-30">
          {testimonials.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              className={`w-2 rounded-full transition-all duration-500 ${
                idx === currentIndex 
                  ? 'h-10 bg-[#0c3754]' 
                  : 'h-2 bg-[#0c3754]/20 hover:bg-[#0c3754]/50'
              }`}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default Testimonials;